import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DeviceTable from "components/deviceTable";
import CorrectionHistoryTable from "components/correctionHistoryTable";
import { setCorrectionHistory } from "store/slices/firebaseSlice";
import { collection, getDocs } from "firebase/firestore";
import { db } from "services/firebase";

function CorrectionHistory() {
  const dispatch = useDispatch();
  const { clientId, correctionHistoryData, deviceIds } = useSelector((state) => state.firebase);
  const [selectedDevice, setSelectedDevice] = useState(null);

  useEffect(() => {
    if (!clientId || !selectedDevice) return;

    const getCorrectionHistory = async () => {
      const correctionHistory = await getDocs(
        collection(db, "Results", clientId, "devices", selectedDevice, "correctionHistory")
      );
      let data = [];
      for (const doc of correctionHistory.docs) {
        const result = doc.data();
        if (result.date && result.date.toDate) {
          result.date = result.date.toDate().toLocaleString();
        }
        data = [...data, result];
      }
      dispatch(setCorrectionHistory(data));
    };
    getCorrectionHistory();
  }, [selectedDevice, clientId, dispatch]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={2.4}>
            <DeviceTable
              clientId={clientId}
              deviceIds={deviceIds}
              selectedDevice={selectedDevice}
              onDeviceSelect={setSelectedDevice}
            />
          </Grid>

          {selectedDevice && (
            <Grid item xs={12} md={9}>
              <CorrectionHistoryTable
                selectedDevice={selectedDevice}
                correctionHistoryData={correctionHistoryData}
              />
            </Grid>
          )}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CorrectionHistory;
